import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

import { SanityImageAndTextSection } from '../../../graphql/gatsby'
import { pageSectionStylesFor } from '../styles'

export const Container = styled.div<
  Pick<SanityImageAndTextSection, 'pageSectionStyles' | 'layout'>
>`
  display: grid;
  grid-template-areas: ${({ layout }) =>
    layout === 'image-right'
      ? `'text'
    'image'`
      : `'image'
    'text'`};
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  gap: 32px;
  padding-left: 2.25rem;
  padding-right: 2.25rem;
  background: linear-gradient(to bottom, #ffffff, #f2f5fb, #ebf4ff);
  ${({ pageSectionStyles }) => pageSectionStylesFor(pageSectionStyles)};
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas: ${({ layout }) =>
      layout === 'image-right' ? '"text image"' : '"image text"'};
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }
  @media (min-width: 992px) {
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }
`

export const Text = styled.div<Pick<SanityImageAndTextSection, 'textAlign'>>`
  grid-area: text;
  align-self: ${({ textAlign }) =>
    textAlign === 'top'
      ? 'start'
      : textAlign === 'center'
        ? 'center'
        : textAlign === 'bottom'
          ? 'end'
          : 'auto'};
`

export const Image = styled(GatsbyImage)`
  grid-area: image;
  object-fit: contain;
  width: 100%;
`
